// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"245":"c9457bae081c8e9b","1063":"79c6a6400c928e04","2888":"e6d4ce9e102ae386","5232":"c9457bae081c8e9b","6213":"c9457bae081c8e9b"}[chunkId] + ".css";
};